module.exports = __webpack_public_path__ + "static/img/icon-trash-line-01.a50f0de3.png";